import {Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit} from '@angular/core';
import {FormBuilder, NgForm, Validators, FormGroup, FormControl} from "@angular/forms";
import * as _ from 'lodash';
import {ModalDirective} from "ngx-bootstrap";
import Popper from 'popper.js';
import Tooltip from 'tooltip.js';
import {AuthService} from "../../../../core/auth/auth.service";
import {AccountaymentModel, AwardTransactionsBeans} from '../../../../core/payments/account-payment.model';
import {MessageService} from "primeng/components/common/messageservice";
import {PromocionesService} from "../../../../core/promociones/promociones.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {InfoModalComponent} from "../../info-modal.component";
import * as moment from 'moment';
import {SetPrincipalModalComponent} from "../../set-principal-modal-component";
import {Promociones, DIMENSION} from "../../promociones";
declare var $;
@Component({
  selector: 'admin-promotion',
  templateUrl: 'admin-promotion.component.html',
  styleUrls: ['admin-promotion.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminPromotionComponent extends Promociones implements OnInit, AfterViewInit {

  /* promotionForm: FormGroup;
  isReadOnly: false; */
  //promotion: any = { principal: true };
  //promotionActive = true;
  //public promotionList: any[] = [];
  /* promotionTypeList: any[] = [];
  isLoading: Boolean = false; */
  //promotionKey;
  //imageDefault: string = "/assets/imgs/thumbnail.svg";
  //imageDefault: string = "https://s3-us-west-2.amazonaws.com/ganalottodo-deploy/campaigns/15_cine/checkEmail/first.svg";
  urlSignup: string = "";


  constructor(
    private formBuilder: FormBuilder,
    public messageService: MessageService,
    private _route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private authService: AuthService,
    public promocionesService: PromocionesService
  ) {
    super(promocionesService, messageService);
    this.isGanalottodo = false;
  }


  ngOnInit() {
    this.initForm(null);
    this._route.params.subscribe(params => {
      this.promotionKey = params['promocion'];
      if (params['promocion'] != 'new') {
        this.retrievePromotion(this.promotionKey);
      } else {
        this.initForm(null);
        this.promotion.principal = false;
      }
    });
    super.ngOnInit();
  }

  ngAfterViewInit() {

  }

  /* private retrievePromotion(key) {
      this.isLoading = true;
      this.promocionesService.getPromotionByKey(key)
          .finally(() => this.isLoading = false)
          .subscribe(
              success => {
                  this.promotion = success;
                  this.initForm(success);

                  console.log('mostramos la promocion: ', success);
              },
              error => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error
                  });
              });
  } */

  initForm(promotionData) {
    /* time: DrawDefTimeLimitComponent.parseTime(this.definition.time),
        time: DrawDefTimeLimitComponent.parseTime(this.definition.time), */
    this.promotionForm = this.formBuilder.group({
      promotionName: [promotionData ? promotionData.name : '', Validators.required],
      promotionType: [promotionData ? promotionData.typePromotion : '', Validators.required],
      startTime: new FormControl(),
      endTime: new FormControl(),
      promotionStartDate: [promotionData ? this.builtObjectDate(promotionData.startDate) : '', Validators.required],
      promotionEndtDate: [promotionData ? this.builtObjectDate(promotionData.endDate) : '', Validators.required],
      promotionDescription: [promotionData ? promotionData.description : '', Validators.required],
      file1: [this.getResource(promotionData, 'forward', 'first', 'file1'), Validators.required],
      file2: [this.getResource(promotionData, 'forward', 'secondary', 'file2'), Validators.required],
      file3: [this.getResource(promotionData, 'forward', 'back', 'file3')],
      file4: [this.getResource(promotionData, 'checkEmail', 'first', 'file4'), Validators.required],

      file5: [this.getResource(promotionData, 'checkEmail', 'footer', 'file5')],

      file6: [this.getResource(promotionData, 'checked', 'first', 'file6'), Validators.required],
      file7: [this.getResource(promotionData, 'checked', 'back', 'file7'), Validators.required],
      file8: [this.getResource(promotionData, 'downloadEmail', 'first', 'file8'), Validators.required],
      file9: [this.getResource(promotionData, 'downloadEmail', 'back', 'file9'), Validators.required],
      file10: [this.promotion.principal == false ? '' : this.getResource(promotionData, 'landing', 'first', 'file10')],
      file11: [this.promotion.principal == false ? '' : this.getResource(promotionData, 'landing', 'secondary', 'file11')],
      file12: [this.promotion.principal == false ? '' : this.getResource(promotionData, 'landing', 'back', 'file12')]
    });

    this.promotionForm.patchValue({
      startTime: promotionData ? AdminPromotionComponent.parseTime(promotionData.startTime) : AdminPromotionComponent.parseTime('09:00'),
      endTime: promotionData ? AdminPromotionComponent.parseTime(promotionData.endTime) : AdminPromotionComponent.parseTime('21:15')
    });

  }

  builtObjectDate(valueAsLong): any {
    const date = new Date(+valueAsLong);
    const dateResult = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
    return dateResult;
  }

  /* private getResource(promotionData, template: string, position: string, fileId: string): string {
      let url = '';
      if (promotionData) {
          let resource = _.find(promotionData.resourcesBeans, resource => {
              return resource.template == template && resource.position == position
          });
          url = resource != undefined ? resource.urlResource : '';
          console.log('se tiene promo principal: ', resource);

          if (/(\.svg)$/i.test(url)) {
              console.log('imagen svg');
              var ajax = new XMLHttpRequest();
              ajax.open("GET", url, true);
              ajax.send();
              ajax.onload = function (e) {
                  console.log('svg', ajax.responseText);
                  $('#up' + fileId).attr('src', 'data:image/svg+xml;utf8,' + ajax.responseText);
              }
          } else {
              $('#up' + fileId).attr('src', url == '' ? this.imageDefault : url);
          }
          $('#' + fileId).prop('type', 'url');
      }
      return url;
  } */

  principalPromotion() {
    this.openPrincipalModal();
  }

  /* activePromotion() {
      this.promotionActive = this.promotionActive ? false : true;
  } */

  /* onSubmit() {
      console.log(this.promotionForm.get('file1').value);
      if (this.promotionForm.valid) {
          let formData = this.fillModel();
          this.isLoading = true;
          this.promocionesService.savePromotion(formData)
              .finally(() => this.isLoading = false)
              .subscribe(response => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'success',
                      summary: '',
                      detail: 'La promoción se guardo exitosamente.'
                  });
                  formData = new FormData();
                  this.goBack();
              },
                  error => {
                      this.messageService.clear();
                      this.messageService.add({
                          severity: 'error',
                          summary: 'Error',
                          detail: error
                      });
                  });
      } else {
          this.messageService.clear();
          this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Es necesario llenar todos los campos'
          });
      }
  } */

  fillModel(): FormData {
    let formData = new FormData($('<form></form>'));
    //formData = this.promotionFormData;
    new FormData($('<form></form>'));
    console.log(this.promotionForm.get('file1').value);
    formData.append("name", this.promotionForm.get('promotionName').value);
    formData.append("description", this.promotionForm.get('promotionDescription').value);
    formData.append("typePromotion", this.promotionForm.get('promotionType').value);
    formData.append("startTime", moment(this.promotionForm.get('startTime').value).format('HH:mm:ss'));
    formData.append("endTime", moment(this.promotionForm.get('endTime').value).format('HH:mm:ss'));
    formData.append("active", this.promotionActive + '');
    formData.append("principal", this.promotion.principal + '');
    formData.append("startDate", this.builtDate(this.promotionForm.value.promotionStartDate).toDateString());
    formData.append("endDate", this.builtDate(this.promotionForm.value.promotionEndtDate).toDateString());
    //formData.append("promotionKey", this.promotionKey);
    _.forEach(this.promotionList, component => {
      formData.append("templateName", component.templateName);
      formData.append("imageName", component.imageName);
      formData.append("imagePosition", component.imagePosition);
      formData.append("resources", component.resources);
    });
    return formData;
  }

  upFile(inputid) {
    $("#" + inputid).prop('type', 'file');
    $("#" + inputid).trigger('click');
  }

  builtDate(dateAsObject): Date {
    const date = new Date(dateAsObject.year, dateAsObject.month - 1, dateAsObject.day);
    console.log(date);
    return date;
  }

  /* uploadFile(event: any, template: string, image: string) {
      this.messageService.clear();
      var allowedExtensions = /(.jpg|.jpeg|.png|.svg)$/i;
      if (!allowedExtensions.exec(event.target.files[0].name)) {
          this.messageService.clear();
          this.messageService.add({
              severity: 'warn',
              summary: '',
              detail: 'Solo es posible cargar archivos con las extensiones: .jpeg/.jpg/.png/.svg'
          });
          return false;
      } else
          if ((event.target.files[0].size / 1024) < 1024) {
              let img = new Image();
              img.onload = () => {
                  console.log(' ancho (width) = ' + img.width + ' , altura (height) = ' + img.height);
                  let fileId = _.find(DIMENSION, item => {
                      return item.component == event.target.id
                  })
                  if (this.promotionList.length > 0) {
                      _.remove(this.promotionList, element => {
                          return element.templateName == template && element.imagePosition == image;
                      });
                  }
                  if (fileId.width == img.width && fileId.height == img.height) {



                      this.promotionList.push(
                          {
                              "templateName": template,
                              "imageName": image + '.' + event.target.files[0].name.split('.')[1],
                              "imagePosition": image,
                              "resources": event.target.files[0]
                          }
                      );
                      this.setPreviewImage(event);
                  } else {
                      this.promotionForm.get(event.target.id).setValue('');

                      let img: any = document.getElementById('up' + event.srcElement.id);
                      img.src = this.imageDefault;

                      this.messageService.clear();
                      this.messageService.add({
                          severity: 'error',
                          summary: '',
                          detail: 'La imagen debe medir: ' + fileId.width + 'px (ancho) x ' + fileId.height + 'px (alto)'
                      });
                  }

              }
              img.src = URL.createObjectURL(event.target.files[0]);


          } else {
              this.messageService.clear();
              this.messageService.add({
                  severity: 'error',
                  summary: '',
                  detail: 'La imagen debe pesar menos de 1 MB'
              });
          }
  } */

  setPreviewImage(principalEvent) {
    var fReader = new FileReader();
    fReader.readAsDataURL(principalEvent.target.files[0]);
    fReader.onloadend = function (event: any) {
      let img: any = document.getElementById('up' + principalEvent.srcElement.id);
      img.src = event.target.result;
    };
  }

  updatePromotion() {
    if (this.promotionForm.valid) {
      let formData = this.fillModel();
      this.isLoading = true;
      this.promocionesService.patchPromotion(formData, this.promotionKey)
        .finally(() => this.isLoading = false)
        .subscribe(
          success => {
            this.messageService.clear();
            this.messageService.add({
              severity: 'success',
              summary: '',
              detail: 'La promoción se actualizo exitosamente.'
            });
            this.goBack();
          },
          error => {
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: '',
              detail: 'ocurrio un problema al actualizar, intentalo nuevamente'
            });
          });
    }
  }

  infoImg(file: string) {
    let fileId = _.find(DIMENSION, item => {
      return item.component == file;
    });
    const modalRef = this.modalService.open(InfoModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.imgURL = fileId.imageInfo;
    modalRef.componentInstance.dimensiones = fileId.width + 'px (ancho) X ' + fileId.height + 'px (alto)';
    modalRef.result.then((result) => {
    }, (reason) => {
      console.log(reason);
    });
  }

  private static parseTime(time: string): Date {

    let momentDate = moment();
    let data = time.split(':');

    momentDate.hours(parseInt(data[0]));
    momentDate.minutes(parseInt(data[1]));
    momentDate.seconds(0);
    momentDate.milliseconds(0);

    return momentDate.toDate();
  }

  goBack() {
    this.router.navigate(['/ganalottodo/promotionsQuantum']);
  }

  openPrincipalModal() {
    const modalRef = this.modalService.open(SetPrincipalModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.promocion = this.promotion;
    //modalRef.componentInstance.promociones = [];//this.promociones;
    modalRef.result.then((result) => {
      console.log(result);
      if (result != 'close')
        this.promotion.principal = result;//this.promotion.principal ? false : true;
      if (this.promotion.principal && this.promotionKey != 'new') {
        setTimeout(() => {
          this.initForm(this.promotion);
        });
      }
    }, (reason) => {
      console.log(reason);
    });
  }


}


/* export const DIMENSION = {
    file1: { component: 'file1', name: 'forward_first', width: 426, height: 409, imageInfo: '/assets/imgs/promotions/forwardP.jpg' },
    file2: { component: 'file2', name: 'forward_secondary', width: 346, height: 367, imageInfo: '/assets/imgs/promotions/forwardS.jpg' },
    file3: { component: 'file3', name: 'forward_back', width: 758, height: 636, imageInfo: '/assets/imgs/promotions/forwardB.jpg' },

    file4: { component: 'file4', name: 'checkEmail_first', width: 426, height: 409, imageInfo: '/assets/imgs/promotions/checkEmailP.jpg' },
    file5: { component: 'file5', name: 'checkEmail_footer', width: 734, height: 85, imageInfo: '/assets/imgs/promotions/checkEmailF.jpg' },

    //file6: { name:'checked_first', width: 345, height: 281 },
    file6: { component: 'file6', name: 'checked_first', width: 346, height: 367, imageInfo: '/assets/imgs/promotions/checkedP.jpg' },
    file7: { component: 'file7', name: 'checked_back', width: 1001, height: 1215, imageInfo: '/assets/imgs/promotions/checkedB.jpg' },

    file8: { component: 'file8', name: 'downloadEmail_first', width: 346, height: 367, imageInfo: '/assets/imgs/promotions/downloadEmailP.jpg' },
    file9: { component: 'file9', name: 'downloadEmail_back', width: 758, height: 636, imageInfo: '/assets/imgs/promotions/downloadEmailB.jpg' },

    file10: { component: 'file10', name: 'landing_first', width: 426, height: 409, imageInfo: '/assets/imgs/promotions/landingP.jpg' },
    file11: { component: 'file11', name: 'landing_secondary', width: 346, height: 367, imageInfo: '/assets/imgs/promotions/landingS.jpg' },
    file12: { component: 'file12', name: 'landing_back', width: 3411, height: 595, imageInfo: '/assets/imgs/promotions/landingB.jpg' }
} */



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/quantum/admin-promotion/admin-promotion.component.ts